module.exports = __webpack_public_path__ + "img/blank-img.12e63893.png";